import {
  isObject, isUndefined, isNumber, isNull
} from './type';
import * as utilNumber from './number';

function safeGet(obj, key) {
  if (!isObject(obj)) {
    obj = {};
  }
  return obj[key];
}

/**
 * 获取对象的属性值（深遍历）
 *
 * @export
 * @param {*} obj 源对象。obj为 null, undefined也不会报错
 * @param {string} key 属性键：`user.address.street`
 * @param {*} defaultValue 默认值
 * @return {*} 返回值
 */
export function get(obj, key, defaultValue) {
  const keys = key.split('.');

  keys.forEach((key) => {
    obj = safeGet(obj, key);
  });

  return (isUndefined(obj) || isNull(obj)) ? defaultValue : obj;
}

/**
 * 设置对象属性值
 *
 * @export
 * @param {object} obj
 * @param {string} key
 * @param {*} value
 * @returns {object}
 */
export function set(obj, key, value) {
  if (!isObject(obj)) {
    throw new TypeError('obj is not Object');
  }

  let tail = obj;
  const keys = key.split('.');
  const last = keys.length - 1;
  keys.forEach((key, index) => {
    if (last === index) {
      tail[key] = value;
    } else {
      // 循环赋值
      let tailValue = tail[key];
      if (!isObject(tailValue)) {
        // array or object
        tailValue = isNumber(utilNumber.cast(key)) ? [] : {};
      }
      tail[key] = tailValue;
      tail = tail[key];
    }
  });

  return obj;
}

export function clone(s) {
  return JSON.parse(JSON.stringify(s));
}

/**
 * 遍历处理对象每个 key
 * 如
 * {
 *   a: 1,
 *   b: 2,
 *   c: {
 *     d: 3,
 *     e: 4
 *   }
 * }
 * @param object
 * @param fn 接受两个参数 key value
 * fn('a', 1)
 * fn('b', 2)
 * fn('c.d', 3)
 * fn('c.e', 4)
 */
export const walk = (object, fn) => {
  const loop = (object, prefix, callback) => {
    Object.entries(object).forEach((entry) => {
      const [key, value] = entry;
      if (isObject(value)) {
        loop(value, key, callback);
        return;
      }
      callback(prefix ? `${prefix}.${key}` : key, value);
    });
  };
  loop(object, '', fn);
};

const dive = (currentKey, source, target) => {
  Object.keys(source).forEach((key) => {
    let k = key;
    const v = source[key];

    if (currentKey.length > 0) {
      k = `${currentKey}.${key}`;
    }

    if (typeof v === 'object') {
      dive(k, v, target);
    } else {
      target[k] = v;
    }
  });
};

export const flatten = (source) => {
  const target = {};

  dive('', source, target);

  return target;
};
